import { render } from "./Contact_page_en.vue?vue&type=template&id=6f725c34&scoped=true"
import script from "./Contact_page_en.vue?vue&type=script&lang=js"
export * from "./Contact_page_en.vue?vue&type=script&lang=js"

import "./Contact_page_en.vue?vue&type=style&index=0&id=6f725c34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f725c34"

export default script